module.exports = __webpack_public_path__ + "static/media/biopharma-dynamics.68e62235.png";